import { Hash } from "~/interfaces/hashInterfaces";
import { IProcessFlowStepConstructorOptions, IProcessFlowVariable } from "~/interfaces/processFlowInterfaces";
import { ConditionalFieldDefinition } from "~/models/conditionalRules/conditionalFieldDefinition";
import ConditionalRuleSet from "~/models/conditionalRules/conditionalRuleSet";
import ConditionalRuleSetFactory from "~/models/conditionalRules/conditionalRuleSetFactory";
import IConditionalRuleReferencedControl from "~/models/conditionalRules/referencedControl";
import FindCountStepConditionalRuleSet from "~/models/processFlows/findCountStepConditionalRuleSet";
import ProcessFlowStep from "~/models/processFlows/processFlowStep";
import ProcessFlowStepElementConditionalFields from "~/models/processFlows/processFlowStepElementConditionalFields";
import ProcessFlowMappedVariable from "~/models/processFlows/steps/processFlowMappedVariable";
import { ProcessFlowStepType } from "../../../enums/processFlowStepType";
import ProcessFlow from "../processFlow";
import ProcessFlowVariable from "../processFlowVariable";
import IterationStep from "./iterationStep";

export class ProcessFlowFindCountStep extends ProcessFlowStep {
  step_type: ProcessFlowStepType.FindCount
  search_criteria_conditional_rule_sets: Hash<FindCountStepConditionalRuleSet> = {};
  search_criteria_mapped_variable_references: Hash<ProcessFlowMappedVariable> = {};
  destination_variable_client_id: string;
  source_variable_client_id: string;

  constructor(parent: ProcessFlow | IterationStep, options: IProcessFlowStepConstructorOptions) {
    super(parent, options);
    this.defineProperty('destination_variable_client_id', null)
    this.defineProperty('source_variable_client_id', null);

    if (!(options.json?.search_criteria_conditional_rule_sets?.length > 0)) {
      this.createDefaultRuleSet();
    }
  }

  createDefaultRuleSet(): void {
    if (Object.values(this.search_criteria_conditional_rule_sets).length > 0) return;
    const searchCriteriaRuleSet = ConditionalRuleSetFactory.createForContainer(this, ProcessFlowStepElementConditionalFields.SEARCH_CRITERIA, {}, false, true);
    searchCriteriaRuleSet.conditionalRulesArray.forEach(rule => {
      if ('is_reference' in rule) rule.is_reference = true
    })
    searchCriteriaRuleSet.attachToParent(this);
  }

  get defaultTitle(): string {
    return `Find ${this.sourceVariable?.referenceModel?.referenceNameOrDefault || "count"}`;
  }

  get destinationVariable(): IProcessFlowVariable {
    return ProcessFlowVariable.repo.find(this.destination_variable_client_id);
  }

  get sourceVariable(): IProcessFlowVariable {
    return ProcessFlowVariable.repo.find(this.source_variable_client_id);
  }

  // ******************** IConditionalRuleContainer START ******************** //
  createNewRuleSet(fieldName: string, definition: ConditionalFieldDefinition): ConditionalRuleSet {
    if (ProcessFlowStepElementConditionalFields.FIND_COUNT_STEP_FIELDS.find(f => f.fieldName === fieldName)) {
      return new FindCountStepConditionalRuleSet(fieldName, definition);
    }
    return super.createNewRuleSet(fieldName, definition);
  }

  getReferencedControl(id: string): IConditionalRuleReferencedControl {
    return this.search_criteria_mapped_variable_references[id] || super.getReferencedControl(id);
  }

  // ******************** IConditionalRuleContainer END ******************** //

  protected mappedVariableReferenceCollectionNames(): readonly string[] {
    return super.mappedVariableReferenceCollectionNames(...ProcessFlowStepElementConditionalFields.FIND_COUNT_STEP_FIELDS.map(definition => definition.fieldName))
  }
}